import _ from 'lodash';
import { apiGet, apiPost } from '../../utils/api';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export type Feature = {
  client_script_exposed?: boolean;
  name: string;
  description: string;
  label: string;
};

export type PostFeatureToggleProps = {
  changeBy: 'emails' | 'account_ids';
  identifiers: string;
  feature: Feature['name'];
  action: 'enable_feature' | 'disable_feature';
};

export function postFeatureToggle({
  changeBy,
  identifiers,
  feature,
  action,
}: PostFeatureToggleProps) {
  const params = {
    feature,
    identifiers: _.uniq(identifiers.split(',')),
    identifier_type: changeBy,
  };

  return apiPost('/features', action, params, 2).then((data) => {
    if (data.success) {
      return Promise.resolve(data.message);
    } else {
      return Promise.reject(data);
    }
  });
}

export function getFeatures(): Promise<{ feature_flags: Feature[] }> {
  return apiGet('/features');
}

export function useGetFeatures(): UseQueryResult<Feature[], Error> {
  return useQuery({
    queryKey: ['useFeatureList'],
    queryFn: () =>
      getFeatures().then(
        (res: { feature_flags: Feature[] }) => res.feature_flags
      ),
  });
}
